import { Box, Container, Typography, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useState } from 'react';
import { LogTabEventToGA } from '../googleAnalytics/GoogleAnalytics';
import { faqAccordionClosedText, faqAccordionOpenedText } from '../googleAnalytics/GoogleAnalyticsConstants';

// FAQ data for Publisher
export const publisherFaqs = [
  {
    question: 'What types of agents can I publish?',
    answer:
      'Our marketplace supports a wide range of AI agents, including but not limited to: data analysis, content creation, research assistants, productivity tools, customer service, education, and specialized industry solutions. The key requirement is that your agent provides genuine value through conversational AI.',
  },
  {
    question: "What's the review process for new agents?",
    answer:
      'Once the agent code is published and a pull request is created (refer to the <a href="/agent-publishing-journey#your-agent-publishing-journey" target="_self">Agent Publishing Journey</a>), the code goes through a review and merge process. Once merged, the code gets pulled in by our CI/CD pipeline and is published to the agent marketplace.',
  },
];

// FAQ data for User Agent
export const userAgentFaqs = [
  {
    question: 'How do I get started with using agents?',
    answer:
      'You can try the agent and contact the author of the agent for additional questions. Agents can be installed on your local machine or used as part of a workflow.',
  },
];

// Faq Component
type FaqProps = {
  faqs: {
    question: string;
    answer: string;
  }[];
};

const Faq: React.FC<FaqProps> = ({ faqs }) => {
  const [expandedIndex, setExpandedIndex] = useState<number | false>(0);

  const handleChange = (panel: number) => (event: React.SyntheticEvent, isExpanded: boolean) => {
    setExpandedIndex(isExpanded ? panel : false);
    LogTabEventToGA(
      isExpanded
        ? `${faqAccordionOpenedText}${faqs[panel].question}`
        : `${faqAccordionClosedText}${faqs[panel].question}`
    );
  };
  return (
    <Box sx={{ py: 8, backgroundColor: '#f8f9fa' }}>
      <Container maxWidth="md">
        <Typography variant="h4" fontWeight={700} textAlign="center" sx={{ mb: 1 }}>
          Frequently Asked Questions
        </Typography>
        <Box
          sx={{
            width: 60,
            height: 4,
            backgroundColor: '#1976d2',
            borderRadius: 2,
            mx: 'auto',
            mb: 5,
          }}
        />
        <Box>
          {faqs.map((faq, index) => {
            const isExpanded = expandedIndex === index;
            return (
              <Accordion
                key={index}
                sx={{
                  mb: 2,
                  borderRadius: '1rem',
                  boxShadow: isExpanded ? 3 : 1,
                  backgroundColor: '#fff',
                }}
                expanded={isExpanded}
                onChange={handleChange(index)}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls={`faq-${index}-content`}
                  id={`faq-${index}-header`}
                  sx={{
                    backgroundColor: '#fff',
                  }}
                >
                  <Typography fontWeight="bold">{faq.question}</Typography>
                </AccordionSummary>
                <AccordionDetails
                  sx={{
                    backgroundColor: '#fafafa',
                    textAlign: 'left',
                  }}
                >
                  <Typography
                    variant="body2"
                    dangerouslySetInnerHTML={{
                      __html: faq.answer,
                    }}
                  />
                </AccordionDetails>
              </Accordion>
            );
          })}
        </Box>
      </Container>
    </Box>
  );
};

export default Faq;
